export class Grouping {
    id: string;
    practice_id: string;
    name: string;
    description: string;
    created: string;
    modified: string;

    constructor(name) {
      this.name = name;
    }
}


// WEBPACK FOOTER //
// ./src/models/groupings.ts